import Model from "./base/model";

class QuotationProposal extends Model{
  resourceName() {
    return "quotation_proposals";
  }

  fields() {
    return {
      name: "",
      path: "",
      monthly_interest: "",
      annual_interest: "",
      installment_value: "",
      installments: "",
      created_at: "",
      cet: "",
      shortage: "",
      is_accept: "",
      decline_message: "",
      quotation_id: "",
      bank_id: "",
      type: "",
      accept_message: "",
      observation: "",
      email_proposal: "",
    }
  }

  async getQuotationProposals(id) {
    return this.request(
      this.resourceName() + "/" + id,
      "GET",
      {},
      {},
    );
  }
}

export default new QuotationProposal();
